<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>





<div *ngIf="completeflag == 0">
  <h3 style="color: #9b7544; margin-left: 40%; margin-top: 30px"> Select Any Services </h3>
  <div style="margin-top: 70px">
    <mat-radio-group >
        <mat-radio-button class="text-left" style="margin-left: 28%" *ngFor="let o of otherpaidservice" [value]="o.name"
                     (change)="radioChange(o.name)">
            {{o.name}}
        </mat-radio-button>

    </mat-radio-group>
  </div>

<div style="margin-left: 30%; margin-top: 20px" class="container-login" *ngIf="formcheck == 1" >
  
 
 <h3 style="color: #9b7544">Fees: Rs. {{servicefees}}/- </h3>
 <h3 style="color: #9b7544">Duration: {{servicedescription}} </h3>
  
      <div class="row" style="margin-top: 20px">

          <mat-card style="background-color: #dbd3be; border-radius: 25px">
            <mat-card-content>
            <div class="form-group"  >

                <form [formGroup]="registrationform"  (ngSubmit)=" submit()">
                  <div class="row" style="margin-top: 20px">
                    <div class="col-sm-12 col-lg-6 col-xl-6">
                    <div class="wrap-inputlogin form-group">

                 <label style="color: #9b7544"> Name: </label>   <input type="text" name="name" placeholder="Enter your Name" id="name" [(ngModel)]="registrationform.name" class="inputlogin form-control" formControlName="name" >
                    <span class="symbol-inputlogin">
                    
                    </span>
                    </div>
                    <div  *ngIf="( registrationform.get('name').hasError('required') ) && registrationform.get('name').touched">

                            <div class="error" style="color:red;font-size:15px" *ngIf="registrationform.get('name').hasError('required') && registrationform.get('name').touched">
                            Name is required
                          </div>
                    </div>

                  </div>
                  <div class="col-sm-12 col-lg-6 col-xl-6">
                    <div class="wrap-inputlogin form-group">
                        
                                         <label style="color: #9b7544"> Pet Name: </label>   <input type="text" name="petname" placeholder="Enter your Pet's Name" id="petname" [(ngModel)]="registrationform.petname" class="inputlogin form-control" formControlName="petname" >
                                            <span class="symbol-inputlogin">
                                            
                                            </span>
                                            </div>
                                            <div  *ngIf="( registrationform.get('petname').hasError('required') ) && registrationform.get('petname').touched">
                        
                                                    <div class="error" style="color:red;font-size:15px" *ngIf="registrationform.get('petname').hasError('required') && registrationform.get('petname').touched">
                                                   Pet Name is required
                                                  </div>
                                            </div>

                  </div>
                </div>
                <div class="row" style="margin-top: 20px">
                    <div class="col-sm-12 col-lg-6 col-xl-6">

                    <div class="wrap-inputlogin form-group">

                        <label style="color: #9b7544"> Email: </label>   <input type="email" placeholder="Enter email Id" name="email" id="email" [(ngModel)]="registrationform.email" class="inputlogin form-control" formControlName="email">
                    <span class="symbol-inputlogin">
                     
                    </span>
                    </div>

                    <div *ngIf="(registrationform.get('email').hasError('pattern') ) && registrationform.get('email').touched">

                             
                                <div class="error" style="color:red;font-size:15px" *ngIf="registrationform.get('email').hasError('pattern') && registrationform.get('email').touched">
                                            Enter Correct Email Id
                                </div>
                    </div>
                    </div>
                    <div class="col-sm-12 col-lg-6 col-xl-6">



                    <div class="wrap-inputlogin form-group">

                        <label style="color: #9b7544"> Mobile: </label>  <input type="mobile" placeholder="Enter Mobile No" name="mobile" id="mobile" [(ngModel)]="registrationform.mobile" class="inputlogin form-control" formControlName="mobile" required>
                    <span class="symbol-inputlogin">
                 
                    </span>
                    </div>

                    <div  *ngIf="( registrationform.get('mobile').hasError('required')  || registrationform.get('mobile').hasError('minLength') ) && registrationform.get('mobile').touched">

                      <div class="error" style="color:red;font-size:15px" *ngIf="registrationform.get('mobile').hasError('required') && registrationform.get('mobile').touched">
                        Mobile Number is required
                      </div>
                      <div class="error" style="color:red;font-size:15px" *ngIf="registrationform.get('mobile').hasError('minLength') && registrationform.get('mobile').touched">
                        This is not a valid Mobile Number
                      </div>

                    </div>

                    </div>
                </div>


                <div class="row" style="margin-top: 20px">
                    <div class="col-sm-12 col-lg-6 col-xl-6">
                    <div class="wrap-inputlogin form-group">
                        <label style="color: #9b7544">No. of Pets: </label> <input type="noofpets" placeholder="No of Pets" name="noofpets" id="noofpets"  [(ngModel)]="registrationform.noofpets" class="inputlogin form-control" formControlName="noofpets" required>
                    <span class="symbol-inputlogin">
                      
                    </span>

                    </div>

                    <div *ngIf="( registrationform.get('noofpets').hasError('required') ) && registrationform.get('noofpets').touched">

                                          <div class="error" style="color:red;font-size:15px" *ngIf="registrationform.get('noofpets').hasError('required') && registrationform.get('noofpets').touched">
                                          No of Pets is required
                                          </div>

                                        </div>


                    </div>
                    <div class="col-sm-12 col-lg-6 col-xl-6">



                      <div class="wrap-inputlogin form-group">
                          <label style="color: #9b7544">Select Date: </label>  <input type="date" placeholder="Date" name="date" id="date"  [(ngModel)]="registrationform.date" class="inputlogin form-control"  min="{{today}}"  formControlName="date" required>
                    <span class="symbol-inputlogin">
                      
                    </span>

                    </div>

                    <div *ngIf="( registrationform.get('date').hasError('required') ) && registrationform.get('date').touched">

                                          <div class="error" style="color:red;font-size:15px" *ngIf="registrationform.get('date').hasError('required') && registrationform.get('date').touched">
                                          Date is required
                                          </div>

                                        </div>

                    </div>
                </div>

                                        <div class="form-group" *ngIf="paidserviceid == 7">
                                            <label style="color: #9b7544">Select Time Slots</label>
                                            <select   name="time" id="time" [(ngModel)]='registrationform.time' class="form-control"   formControlName="time"  >
                                              <option *ngFor="let data of timeslots" value="{{data}}" >{{data}}</option>
                                              </select>
                                            </div>




                                <div class="row">
                                    <div class="col-12">
                                            <button  class="btn btn-outline-success btn-block" style=" border-radius: 25px;color: #9b7544" type="submit" [disabled]="!registrationform.valid">Submit</button>
                                    </div>


                                      </div>
        </form>
                </div>
            </mat-card-content>
          </mat-card>

  </div>

</div>
</div>

<div *ngIf="completeflag == 1"> 
  <a style="font-size: 40px; color: #9b7544; margin-left: 30%; margin-top: 30px"> 
    Your Extra Services Booking is Confirmed. </a>
</div>



